import type {Theme} from '@emotion/react';

interface VariablesProps {
    $activeBorderColor?: string;
    theme: Theme;
}

/**
 * Generates CSS variables for TagCloudView component styling.
 *
 * @param props                    The properties object.
 * @param props.$activeBorderColor Optional custom border color for active state.
 * @param props.theme              The theme object containing color definitions.
 * @returns A string containing CSS variable definitions.
 */
export const getBaseVariables = ({$activeBorderColor, theme}: VariablesProps) => `
    --border-color: ${$activeBorderColor ?? theme.colors.primary};
    --background-color: ${theme.colors.neutral0};
`;